import React, { useState } from "react";
import { MdImage, MdKeyboardArrowRight } from "react-icons/md";
const SelectBackgroundEdit = ({
  layerID,
  backgrounds,
  backgroundDesign,
  onChangeBgCurrentEditID,
  onChangeBackground,
}) => {
  const [open, setOpen] = useState(true);
  const handleChoose = (id) => {
    if (layerID == id) {
      return;
    }
    const findBg = backgrounds.find((e) => e.id == id);
    onChangeBackground(id, findBg);
    setTimeout(() => {
      onChangeBgCurrentEditID(id);
    }, 100);
  };
  return (
    <>
      <div
        style={{
          opacity: backgrounds.length <= 0 ? "0.5" : "1",
          pointerEvents: backgrounds.length <= 0 ? "none" : "all",
        }}
        className="box-select-backgrounds"
      >
        <div
          onClick={() => setOpen((prev) => !prev)}
          className="box-select-backgrounds__item btn"
        >
          <div className="box-select-backgrounds__item__img">
            <img
              style={{
                height: "100%",
              }}
              src={backgroundDesign.imageUrl}
            />
          </div>
          <div className="box-select-backgrounds__item__icon">
            <MdKeyboardArrowRight />
          </div>
        </div>
        {open && (
          <div className="box-select-backgrounds__list">
            {backgrounds.map((e) => (
              <div
                key={e.id}
                onClick={() => handleChoose(e.id)}
                className={
                  layerID == e.id
                    ? "box-select-backgrounds__item box-select-backgrounds__item_active"
                    : "box-select-backgrounds__item"
                }
              >
                <div className="box-select-backgrounds__item__img">
                  <img
                    style={{
                      height: "100%",
                    }}
                    src={e.imageUrl}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SelectBackgroundEdit;
